import * as React from 'react';
import { connect } from 'react-redux';
import { SwordSearch, ConfigurationSwitchView, ConfigurationList } from 'src/app/Partials';
import { ConfigurationsDispatcher, GroupsDispatcher } from 'src/app/Container';
import { GlobalPrivateState, validateConfiguration, plateBuilder, warnings } from 'src/api';
import { requestAPIActions } from 'loopback-react-request';
import { match as Match } from 'react-router';

import './Folder.page.scss';
import TroughBanner from 'src/app/Partials/TroughBanner/TroughBanner';
import FolderList from 'src/app/Partials/Configuration/List/FolderList';
import FolderSwitchView from 'src/app/Partials/Configuration/SwitchView/FolderSwitchView';

export interface FolderPageProps {
  checkout: GlobalPrivateState['checkout'];
  configuration: GlobalPrivateState['configuration'];
  trough: GlobalPrivateState['trough'];
  troughs: GlobalPrivateState['troughs'];
  order: GlobalPrivateState['order'];
  groups: GlobalPrivateState['groups'];
  match: Match<{folderId: string}>;
  dispatch: Function;
}

export class FolderPageComponent extends React.Component<FolderPageProps> {

  componentDidMount() {
    this.clearConfigurationStates();
  }

  componentDidUpdate() {   
    this.clearConfigurationStates();
  }

  componentWillUnmount() {
    this.props.dispatch(requestAPIActions.loadCleared('configurations'));
  }

  public render() {
    const { groups } = this.props;
    const currentGroup = this.folderId && groups && groups.result && Array.isArray(groups.result) && groups.result.find(g => g.id === this.folderId);
    const canCreateFolder = !currentGroup || (currentGroup && !currentGroup.parentId);

    return (
      <div className="page-configurations">
        <GroupsDispatcher parentId={this.folderId} />
        <div className="page-configuration-list pb-3">
          <div className="container">
            <div style={{visibility: 'hidden'}}><SwordSearch /></div>
            <div className="view-switcher">
              <div className="col-12 p-0">
                <FolderSwitchView folderId={this.folderId} />
              </div>
            </div>
            {currentGroup && (
              <>
                <h5 className="heading heading--main">{currentGroup.name}</h5>
                <h6 className="subheading">{currentGroup.parentId ? 'ON' : 'BN'}: {currentGroup.metavalue}</h6>
              </>
            )}
            {canCreateFolder && (
              <FolderList folderId={this.folderId} />
            )}
            <ConfigurationList folderId={this.folderId} />
          </div>
        </div>
      </div>
    );
  }

  private clearConfigurationStates(): void {
    const {
      checkout,
      configuration,
      dispatch,
      trough,
      troughs,
      order,
    } = this.props;

    if (checkout && checkout.result) {
      dispatch(requestAPIActions.loadCleared('checkout'));
    }
    
    if (configuration && configuration.result) {
      dispatch(requestAPIActions.loadCleared('configuration'));
    }

    if (trough && trough.result) {
      dispatch(requestAPIActions.loadCleared('troughs'));
    }

    if (troughs && troughs.result) {
      dispatch(requestAPIActions.loadCleared('troughs'));
    }

    if (order && order.result || order && order.error) {
      dispatch(requestAPIActions.loadCleared('order'));
    }

    // Clear all validations, calculations, warnings...
    this.props.dispatch(validateConfiguration.clear());
    this.props.dispatch(plateBuilder.clear());
    this.props.dispatch(warnings.clear());
  }

	private get folderId(): string | undefined {
    const { match } = this.props;
    return match && match.params && match.params.folderId;
  }
}

export const FolderPage = connect((state: GlobalPrivateState) => ({
  checkout: state.checkout,
  configuration: state.configuration,
  trough: state.trough,
  troughs: state.troughs,
  order: state.order,
  groups: state.groups
}))(FolderPageComponent);